import './src/vaadin-email-field.js';

export * from './src/vaadin-email-field.js';
